/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export enum StatStageType {
  COMPLETED = 'COMPLETED',
  FIRST_DRAFT = 'FIRST_DRAFT',
  DUE_TODAY = 'DUE_TODAY',
  SUPPLEMENTAL_RECEIVED = 'SUPPLEMENTAL_RECEIVED',
  PAST_DUE = 'PAST_DUE',
  ANALYST_OPEN_FILES='ANALYST_OPEN_FILES',
  DUE_TOMORROW='DUE_TOMORROW',
  ANALYST_TIER_ERRORS='ANALYST_TIER_ERRORS',
  COMPLETED_REVENUE = "COMPLETED_REVENUE"
}
